import React from "react";
import { useTranslation } from "react-i18next";
import { Checkbox } from "Components/Form";
import { CompanyConfig } from "Models/company.config";
import {
  AppHeaderCell,
  AppTableCell,
  AppTable,
  AppTableBody,
  AppTableContainer,
  AppTableHead,
  AppTableRow,
} from "Components/AppTable";

export const InventoryTable: React.FC<{
  inventoryFieldsConfig: CompanyConfig["settings"]["opsAppConfiguration"]["fieldsRelatedSettings"]["inventoryFieldsConfig"];
  onChange: (fieldKey: string, property: string, value: boolean) => void;
}> = ({ inventoryFieldsConfig, onChange }) => {
  const { t: translate } = useTranslation();

  // Get the keys of the inventoryFieldsConfig object
  const fieldKeys = Object.keys(inventoryFieldsConfig) as Array<keyof typeof inventoryFieldsConfig>;

  // Translation for table headers
  const columnHeaders = {
    field: translate("inventoryFields"),
    mandatory: translate("mandatory"),
    autofill: translate("autofillBasedOnTheTask"),
    multipleSelection: translate("allowMultipleSelection"),
  };

  return (
    <AppTableContainer>
      <AppTable>
        <AppTableHead>
          <AppTableRow>
            <AppHeaderCell>{columnHeaders.field}</AppHeaderCell>
            <AppHeaderCell>{columnHeaders.mandatory}</AppHeaderCell>
            <AppHeaderCell>{columnHeaders.autofill}</AppHeaderCell>
          </AppTableRow>
        </AppTableHead>
        <AppTableBody>
          {fieldKeys.map((fieldKey) => {
            const fieldConfig = inventoryFieldsConfig[fieldKey];
            // Translate field name for display
            const displayName = translate(fieldKey.toString());

            // Check if the field supports multiple selection
            const supportsMultipleSelection = "multipleSelection" in fieldConfig;

            return (
              <AppTableRow key={fieldKey} style={{ height: "64px" }}>
                <AppTableCell>{displayName}</AppTableCell>
                <AppTableCell>
                  <Checkbox
                    checked={fieldConfig.mandatory}
                    onChange={() =>
                      onChange(fieldKey.toString(), "mandatory", !fieldConfig.mandatory)
                    }
                  />
                </AppTableCell>
                <AppTableCell>
                  <Checkbox
                    checked={fieldConfig.autofill}
                    onChange={() =>
                      onChange(fieldKey.toString(), "autofill", !fieldConfig.autofill)
                    }
                  />
                </AppTableCell>
              </AppTableRow>
            );
          })}
        </AppTableBody>
      </AppTable>
    </AppTableContainer>
  );
};
